import styled from "styled-components";

export const CreateDropdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  > svg {
    position: absolute;
    right: 10px;
    top: 10px;
    width: 8px;
    z-index: 2;
    transition: 0.2s;
    transform: ${(props) => (props.showDropdown ? "rotate(90deg)" : "rotate(0deg)")};
    & path {
      fill: ${(props) => props.theme.textColor};
    }
  }
  & span {
    padding: 10px 18px;
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 126.2%;
    color: ${(props) => props.theme.textColor};
    background: ${(props) => props.theme.bgColor};
    @media (max-width: 767.98px) {
      font-size: 16px;
    }
  }
  > span {
    background: ${(props) => props.theme.hover};
  }
`;

export const CreateDropdownMain = styled.div`
  display: flex;
  flex-direction: column;
  height: auto;
  max-height: ${(props) => (props.showDropdown ? "500px" : "0")};
  cursor: pointer;
  display: flex;
  align-items: right;
  justify-content: center;
  transition: 0.2s;
  overflow: hidden;
`;
